import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import PersonAddIcon from '@material-ui/icons/PersonAdd'
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd' 
import Checkbox from '@material-ui/core/Checkbox'


export default class AddBtn extends React.Component {
    handleClick(e) {
        const node = this.refs.input
        const text = node.value.trim()
        this.props.onAddClick(text)
        node.value = ''
    }
    render() {
        const buttonStyle = {
            height: 40,
            width: 175,
            fontSize:22,
            borderRadius: 5,
            border: '1px solid #7F7F7F',
            paddingLeft: 5
        }
        const root = {
            backgroundColor: '#eadbeb',
            width: '100%',
            textAlign:'center',
            paddingTop: 5
        }
        const {isShowCheckbox} = this.props
        return (
            <div style={root}>
                {isShowCheckbox && <Checkbox style={{opacity: 0,marginRight: -15}} />}
                <input type="text" ref="input" style={buttonStyle} />
                <IconButton onClick={(e) => this.handleClick(e)}>{isShowCheckbox ? <PlaylistAddIcon /> : <PersonAddIcon />}</IconButton>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/home/routes/permission/components/addBtn.js